import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { Badge } from 'foundations-components/transitional/components/Badge';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSidePanelLayoutContext } from './SidePanelLayoutContext';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const BadgeWrapper = styled.span.withConfig({
  displayName: "StepCounterBadge__BadgeWrapper",
  componentId: "c03ahd-0"
})(["> *{text-transform:none;}"]);
export const StepCounterBadge = _ref => {
  let props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  const {
    currentStepNumber,
    totalSteps
  } = useSidePanelLayoutContext();
  return /*#__PURE__*/_jsx(BadgeWrapper, {
    children: /*#__PURE__*/_jsx(Badge, Object.assign({
      use: "koala",
      display: "block"
    }, props, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "sidePanelLayout.stepCounterBadge",
        options: {
          currentStepNumber,
          totalSteps
        }
      })
    }))
  });
};